import React, { lazy } from 'react'
import { DomainRoute } from 'domains/retailer-collections/utils/domain/routingComponents'
import { retailerCollectionsAccessControl } from 'domains/retailer-collections/access-control/retailerCollectionsAccess.configuration'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'
import InstacartCollectionsEditPage from 'domains/retailer-collections/pages/instacart-edit/InstacartCollectionsEditPage'

const RetailerCollectionsBrowsePage = lazy(
  () =>
    import(
      /* webpackChunkName: "RetailerCollectionsBrowsePage" */
      'domains/retailer-collections/pages/browse/RetailerCollectionsBrowsePage'
    )
)
const RetailerCollectionsCreatePage = lazy(
  () =>
    import(
      /* webpackChunkName: "RetailerCollectionsCreatePage" */
      'domains/retailer-collections/pages/create/RetailerCollectionsCreatePage'
    )
)
const RetailerCollectionsEditPage = lazy(
  () =>
    import(
      /* webpackChunkName: "RetailerCollectionsEditPage" */
      'domains/retailer-collections/pages/edit/RetailerCollectionsEditPage'
    )
)
const RetailerCollectionsDuplicatePage = lazy(
  () =>
    import(
      /* webpackChunkName: "RetailerCollectionsDuplicatePage" */
      'domains/retailer-collections/pages/duplicate/RetailerCollectionsDuplicatePage'
    )
)
const InstacartCollectionsDuplicatePage = lazy(
  () =>
    import(
      /* webpackChunkName: "RetailerCollectionsDuplicatePage" */
      'domains/retailer-collections/pages/instacart-duplicate/InstacartCollectionsDuplicatePage'
    )
)
const RetailerCollectionsBulkUploadPage = lazy(
  () =>
    import(
      /* webpackChunkName: "RetailerCollectionsBulkUploadStructurePage" */
      'domains/retailer-collections/pages/bulk/RetailerCollectionsBulkUploadPage'
    )
)
// @hygen:inject page-import

export const retailerCollectionsRouter = (
  <DomainRoute route="retailer-collections" accessControl={retailerCollectionsAccessControl}>
    <DashSwitch>
      <DomainRoute route="retailer-collections-browse" component={RetailerCollectionsBrowsePage} />
      <DomainRoute
        exact
        route="retailer-collections-create"
        component={RetailerCollectionsCreatePage}
      />
      <DomainRoute
        exact
        route="retailer-collections-edit"
        component={RetailerCollectionsEditPage}
      />
      <DomainRoute
        exact
        route="retailer-collections-duplicate"
        component={RetailerCollectionsDuplicatePage}
      />
      <DomainRoute
        exact
        route="retailer-collections-ic-duplicate"
        component={InstacartCollectionsDuplicatePage}
      />
      <DomainRoute
        exact
        route="retailer-collections-ic-edit"
        component={InstacartCollectionsEditPage}
      />
      <DomainRoute
        exact
        route="retailer-collections-bulk-upload-structure"
        component={RetailerCollectionsBulkUploadPage}
      />
      <DomainRoute
        exact
        route="retailer-collections-bulk-upload-products"
        component={RetailerCollectionsBulkUploadPage}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
